module.exports = __webpack_public_path__ + "img/coronavirus_spanish.2053afab.jpg";